import { useMemo } from 'react';

import { useQuery } from '@apollo/client';
import { useRefinementList } from 'react-instantsearch';

import { FILTERS } from '~/const';
import { GET_ALL_SKILLS } from '~/graphql/discover';
import { Query } from '~/types';

const useRefinementSkills = () => {
  const { refine, items } = useRefinementList({
    attribute: FILTERS.Skills,
  });
  const { data } = useQuery<Pick<Query, 'listSkills'>>(GET_ALL_SKILLS);

  const tenantedSkills = useMemo(() => {
    if (data?.listSkills) {
      return items.filter((item1) => data?.listSkills?.some((item2) => item2.id === item1.value));
    }

    return [];
  }, [data, items]);

  const translations = useMemo(
    () =>
      data?.listSkills?.reduce((acc, item) => {
        if (item?.id && item?.title) {
          acc[item.id] = item.title;
        }
        return acc;
      }, {}),
    [data],
  );

  return {
    refine,
    items: tenantedSkills,
    translations,
  };
};

export default useRefinementSkills;
